// SEQ-180 phase 2, task P18: the named sizes the resize control offers.
//
// A select of named sizes, not a drag corner, so there is no mouse-only path
// to resizing a widget (plan section 7.4). Every phase 1 widget's default
// layout is one of these, so the control on an untouched dashboard always
// shows a name rather than a blank.
//
// Pure module so PnlDashboardGrid.tsx exports only components.

import type { PnlWidgetLayout } from "../../lib/pnl/pnlWidgetSchema";

export interface WidgetSizeOption {
  value: string;
  label: string;
  layout: PnlWidgetLayout;
}

export const WIDGET_SIZE_OPTIONS: WidgetSizeOption[] = [
  { value: "1x1", label: "Quarter width", layout: { w: 1, h: 1 } },
  { value: "2x2", label: "Half width", layout: { w: 2, h: 2 } },
  { value: "3x2", label: "Three quarter width", layout: { w: 3, h: 2 } },
  { value: "4x2", label: "Full width", layout: { w: 4, h: 2 } },
  { value: "4x3", label: "Full width, tall", layout: { w: 4, h: 3 } },
];

export function widgetSizeValue(layout: PnlWidgetLayout): string {
  const exact = WIDGET_SIZE_OPTIONS.find((o) => o.layout.w === layout.w && o.layout.h === layout.h);
  return exact ? exact.value : `${layout.w}x${layout.h}`;
}
